const masterclass = {
    "LBL_PAGE_TITLE":"Masterclass",
    "LBL_PAGE_HEADER":"Invită prietenii și primește 2 lecții gratuite!",
    "LBL_PAGE_DESCRIPTION":"Trimiteți prietenilor un link sau un cod - după prima plată a unui prieten, amândoi veți primi lecții gratuite. Condiții complete ale promoției",
    "LBL_REFERRAL_PAGE_TITLE":"Partajează link-ul sau codul unui prieten",
    "LBL_REFERRAL_STEP_1_DESCRIPTION":"Împărtășiți-vă cu codul sau link-ul dvs în orice mod convenabil",
    "LBL_REFERRAL_STEP_2_DESCRIPTION":"Prietenii prin link se înscriu pentru a participa la o lecție introductivă sau indică codul la prima plată",
    "LBL_REFERRAL_STEP_3_DESCRIPTION":"Un prieten achită un abonament și ambii primiți 2 lecții suplimentare",
    "LBL_LINK_COPYIED":"Link-ul a fost copiat"
};
export default masterclass;